<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.33305 9.8031L12.0004 3L16.667 9.8031L22 5.72153L19.3335 17.2862H4.66652L2 5.72153L7.33305 9.8031ZM19.8584 21H4.14282V19H19.8584V21Z"
      fill="currentColor"
    />
  </svg>
</template>
